const dateTime = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
});
const dateOnly = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});
const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/** MM/DD/YYYY, hh:mm. Empty string for missing values. */
export const formatDateTime = (iso?: string | null): string =>
  iso ? dateTime.format(new Date(iso)) : '';
export const formatDate = (iso?: string | null): string =>
  iso ? dateOnly.format(new Date(iso)) : '';

export const formatCents = (cents?: number | null): string =>
  cents === null || cents === undefined ? '' : money.format(cents / 100);

/** "12.5" -> 1250. Returns undefined when the text is not a valid non-negative amount. */
export function dollarsToCents(text: string): number | undefined {
  const trimmed = text.trim();
  if (!/^\d+(\.\d{1,2})?$/.test(trimmed)) return undefined;
  return Math.round(Number(trimmed) * 100);
}

export const centsToDollars = (cents?: number | null): string =>
  cents === null || cents === undefined ? '' : (cents / 100).toFixed(2);

/** `null` allowance means unlimited. */
export const formatAllowance = (value: number | null, unit = ''): string =>
  value === null ? 'Unlimited' : `${value.toLocaleString('en-US')}${unit ? ` ${unit}` : ''}`;
